import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService';
import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { IAliasRepository, UpsertAliasRequestBody } from '../entities';

class AliasRepositoryImpl implements IAliasRepository {
  constructor() {
    this.UpsertAlias = this.UpsertAlias.bind(this);
    this.DeleteAlias = this.DeleteAlias.bind(this);
  }

  UpsertAlias(
    customerId: Nullable<string>,
    accountId: Nullable<number>,
    data: UpsertAliasRequestBody,
    successCallback: SuccessCallback,
  ): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: Object.assign({
        method: 'PUT',
        url: `/secure-web/api/private/accounts/alias/${customerId}/${accountId}`,
        dynamicPath: { customerId, accountId },
        data,
        nextCallback: successCallback,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      }),
    });
  }

  DeleteAlias(
    customerId: Nullable<string>,
    accountId: Nullable<number>,
    successCallback: SuccessCallback,
  ): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'DELETE',
        url: `/secure-web/api/private/accounts/alias/${customerId}/${accountId}`,
        dynamicPath: { customerId, accountId },
        nextCallback: successCallback,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }
}

export { AliasRepositoryImpl };
